import { grades } from '@/externals/gyym/user'

export const listGrades = async () => {
  return await grades.list()
}
